import { render, staticRenderFns } from "./Shopdecoration.vue?vue&type=template&id=740aca3a&scoped=true&"
import script from "./Shopdecoration.vue?vue&type=script&lang=js&"
export * from "./Shopdecoration.vue?vue&type=script&lang=js&"
import style0 from "./Shopdecoration.vue?vue&type=style&index=0&id=740aca3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740aca3a",
  null
  
)

export default component.exports